/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Label_Bucket_JumboInputs */

const en_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumbo Bucket`)
};

const es_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cubo jumbo`)
};

const de_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumbo-Eimer`)
};

const zh_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`超大桶`)
};

const ar_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سلة جامبو`)
};

const fr_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seau jumbo`)
};

const vi_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xô jumbo`)
};

const sw_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ndoo Jumbo`)
};

const th_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถังจัมโบ้`)
};

const bs_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumbo kanta`)
};

const ja_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジャンボバケット`)
};

const ko_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`점보 버킷`)
};

const pt_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balde jumbo`)
};

const it_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cestino jumbo`)
};

const sv_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumbohink`)
};

const nl_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumbo emmer`)
};

const da_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumbo-kurv`)
};

const nb_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumbokurv`)
};

const fi_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumbo-ämpäri`)
};

const pl_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koszyk jumbo`)
};

const ru_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Корзина Jumbo`)
};

const tr_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumbo Kova`)
};

const hi_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जंबो बाल्टी`)
};

const id_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ember Jumbo`)
};

const ms_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baldi Jumbo`)
};

const cs_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumbo košík`)
};

const el_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κουβάς Jumbo`)
};

const he_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דלי ג'מבו`)
};

const af_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumbo-emmer`)
};

const hu_prices_label_bucket_jumbo = /** @type {(inputs: Prices_Label_Bucket_JumboInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumbo vödör`)
};

/**
* | output |
* | --- |
* | "Jumbo Bucket" |
*
* @param {Prices_Label_Bucket_JumboInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_label_bucket_jumbo = /** @type {((inputs?: Prices_Label_Bucket_JumboInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Label_Bucket_JumboInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_label_bucket_jumbo(inputs)
	if (locale === "de") return de_prices_label_bucket_jumbo(inputs)
	if (locale === "zh") return zh_prices_label_bucket_jumbo(inputs)
	if (locale === "ar") return ar_prices_label_bucket_jumbo(inputs)
	if (locale === "fr") return fr_prices_label_bucket_jumbo(inputs)
	if (locale === "vi") return vi_prices_label_bucket_jumbo(inputs)
	if (locale === "sw") return sw_prices_label_bucket_jumbo(inputs)
	if (locale === "th") return th_prices_label_bucket_jumbo(inputs)
	if (locale === "bs") return bs_prices_label_bucket_jumbo(inputs)
	if (locale === "ja") return ja_prices_label_bucket_jumbo(inputs)
	if (locale === "ko") return ko_prices_label_bucket_jumbo(inputs)
	if (locale === "pt") return pt_prices_label_bucket_jumbo(inputs)
	if (locale === "it") return it_prices_label_bucket_jumbo(inputs)
	if (locale === "sv") return sv_prices_label_bucket_jumbo(inputs)
	if (locale === "nl") return nl_prices_label_bucket_jumbo(inputs)
	if (locale === "da") return da_prices_label_bucket_jumbo(inputs)
	if (locale === "nb") return nb_prices_label_bucket_jumbo(inputs)
	if (locale === "fi") return fi_prices_label_bucket_jumbo(inputs)
	if (locale === "pl") return pl_prices_label_bucket_jumbo(inputs)
	if (locale === "ru") return ru_prices_label_bucket_jumbo(inputs)
	if (locale === "tr") return tr_prices_label_bucket_jumbo(inputs)
	if (locale === "hi") return hi_prices_label_bucket_jumbo(inputs)
	if (locale === "id") return id_prices_label_bucket_jumbo(inputs)
	if (locale === "ms") return ms_prices_label_bucket_jumbo(inputs)
	if (locale === "cs") return cs_prices_label_bucket_jumbo(inputs)
	if (locale === "el") return el_prices_label_bucket_jumbo(inputs)
	if (locale === "he") return he_prices_label_bucket_jumbo(inputs)
	if (locale === "af") return af_prices_label_bucket_jumbo(inputs)
	if (locale === "hu") return hu_prices_label_bucket_jumbo(inputs)
	return en_prices_label_bucket_jumbo(inputs)
});